import { isNumeric, isHttpUrl } from '../lib';

export function addIcons(ad) {
  const { icons } = ad.linearCreative();
  if (!icons || icons.length === 0) return;

  icons.forEach((icon) => {
    const {
      height, width, staticResource, iframeResource,
      xPosition, yPosition, iconClickThroughURLTemplate, duration,
    } = icon;

    let iconContainer = null;

    // An HTMLResource is not rendered: inserted as markup, the ad's scripts would run in this
    // page's origin.
    if (staticResource) {
      iconContainer = document.createElement('img');
      iconContainer.src = staticResource;
      iconContainer.height = height > 0 ? height : 100;
      iconContainer.width = width > 0 ? width : 100;
    } else if (isHttpUrl(iframeResource)) {
      iconContainer = document.createElement('iframe');
      iconContainer.src = iframeResource;
      iconContainer.height = height > 0 ? height : 100;
      iconContainer.width = width > 0 ? width : 100;
    }

    if (!iconContainer) return;

    iconContainer.style.zIndex = '11';
    iconContainer.style.position = 'absolute';

    // Y positioning
    if (isNumeric(yPosition)) {
      iconContainer.style.top = `${yPosition}px`;
    } else {
      iconContainer.style[['top', 'bottom'].includes(yPosition) ? yPosition : 'top'] = '3em';
    }
    // X positioning
    if (isNumeric(xPosition)) {
      iconContainer.style.left = `${xPosition}px`;
    } else {
      iconContainer.style[['right', 'left'].includes(xPosition) ? xPosition : 'left'] = '0';
    }

    if (isHttpUrl(iconClickThroughURLTemplate)) {
      iconContainer.style.cursor = 'pointer';
      iconContainer.addEventListener('click', () => {
        window.open(iconClickThroughURLTemplate, '_blank');
        this.linearVastTracker.click(iconClickThroughURLTemplate, this.macros);
      });
    }

    this.domElements.push(iconContainer);
    this.video.parentElement.appendChild(iconContainer);

    if (duration !== '-1' && duration !== -1) {
      const durationInSeconds = String(duration).split(':').reverse()
        .reduce((prev, curr, i) => prev + parseFloat(curr) * 60 ** i, 0);
      setTimeout(() => {
        iconContainer.remove();
      }, durationInSeconds * 1000);
    }
  });
}